type FilterValue = string | number | boolean | null | undefined | readonly FilterValue[];
export type AiFilterDrawerSnapshot = Record<string, FilterValue>;

function normalizeFilterValue(value: FilterValue): unknown {
    if (Array.isArray(value)) return value.map(normalizeFilterValue);
    return value ?? null;
}

function normalizeFilters(filters: AiFilterDrawerSnapshot): Record<string, unknown> {
    return Object.fromEntries(
        Object.keys(filters)
            .sort()
            .map(key => [key, normalizeFilterValue(filters[key])]),
    );
}

/**
 * AI result ids should only be cleared when the drawer confirmation represents
 * a real net filter change. The drawer writes URL filters live while it is open;
 * if the user edits a filter and removes it back before confirming, clearing the
 * ids would make the grid fall back to plain Elastic results for the same filters.
 */
export function shouldClearAiActivityIdsOnDrawerConfirm(
    initialFilters: AiFilterDrawerSnapshot | null,
    currentFilters: AiFilterDrawerSnapshot,
): boolean {
    if (!initialFilters) return true;
    return (
        JSON.stringify(normalizeFilters(initialFilters)) !==
        JSON.stringify(normalizeFilters(currentFilters))
    );
}
